<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 36 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.7734 9.25C36.0546 11.2008 36.238 13.8693 35.3639 14.8907C33.9171 16.5794 24.7574 16.5794 24.7574 13.2021C24.7574 11.5011 26.2637 10.3851 24.817 8.69538C23.3939 7.03375 20.8435 7.00675 18.0062 7.00675C15.169 7.00675 12.6186 7.03375 11.1955 8.69538C9.74873 10.384 11.2562 11.5 11.2562 13.2021C11.2562 16.5805 2.09535 16.5805 0.648604 14.8907C-0.225521 13.8693 -0.0432709 11.2008 0.239104 9.25C0.456229 7.94838 1.00298 6.54325 2.7546 4.75C5.3826 2.29862 9.35835 0.293875 17.8656 0.251125V0.25H18.1469V0.251125C26.6541 0.293875 30.6299 2.29862 33.2579 4.75C35.0095 6.54325 35.5562 7.94725 35.7734 9.25Z"
      fill="#FDFFFD"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "36",
    },
    height: {
      type: String,
      default: "16",
    },
  },
};
</script>
